module.exports = __webpack_public_path__ + "img/menuBg.f0bf989f.png";